(function () {
    const selectControl = document.getElementById("related-pages--mobile-select-control");
    if (selectControl) {
        selectControl.addEventListener("change", function (event) {
            console.log(event.target);
            window.location.href = event.target.value;
        });
    }
})();
